"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelDentalOrder = cancelDentalOrder;
exports.createDentalAftersale = createDentalAftersale;
exports.exportDentalOrderList = exportDentalOrderList;
exports.getAppointmentStatusOptions = getAppointmentStatusOptions;
exports.getDentalOrderDetail = getDentalOrderDetail;
exports.getDentalOrderList = getDentalOrderList;
exports.getDentalOrderStatusOptions = getDentalOrderStatusOptions;
exports.getSmsTemplateList = getSmsTemplateList;
exports.sendAppointmentSms = sendAppointmentSms;
exports.shipDentalOrder = shipDentalOrder;
exports.updateAppointmentAddress = updateAppointmentAddress;
exports.updateDentalOrderStatus = updateDentalOrderStatus;
exports.uploadDentalResult = uploadDentalResult;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 获取口腔订单列表
 * @param {Object} params 查询参数
 */
function getDentalOrderList(params) {
  return (0, _request.default)({
    url: '/admin/dental/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取口腔订单详情
 * @param {string} orderNo 订单编号
 */
function getDentalOrderDetail(orderNo) {
  return (0, _request.default)({
    url: '/admin/dental/order/detail',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}

/**
 * 取消口腔预约订单
 * @param {Object} data 取消参数
 */
function cancelDentalOrder(data) {
  return (0, _request.default)({
    url: '/dental/order/cancel',
    method: 'post',
    data: data
  });
}

/**
 * 更新口腔订单状态
 * @param {Object} data 状态更新请求
 */
function updateDentalOrderStatus(data) {
  return (0, _request.default)({
    url: '/admin/dental/order/update-status',
    method: 'post',
    data: data
  });
}

/**
 * 导出口腔订单数据
 * @param {Object} params 查询参数
 */
function exportDentalOrderList(params) {
  return (0, _request.default)({
    url: '/admin/dental/order/export',
    method: 'get',
    params: params
  });
}

/**
 * 获取短信模板列表
 */
function getSmsTemplateList() {
  return (0, _request.default)({
    url: '/admin/dental/sms/template/list',
    method: 'get'
  });
}

/**
 * 发送预约提醒短信
 * @param {Object} data 短信参数
 */
function sendAppointmentSms(data) {
  return (0, _request.default)({
    url: '/admin/dental/sms/send',
    method: 'post',
    data: data
  });
}

/**
 * 修改预约地址
 * @param {Object} data 地址数据
 */
function updateAppointmentAddress(data) {
  return (0, _request.default)({
    url: '/admin/dental/order/address',
    method: 'put',
    data: data
  });
}

/**
 * 创建售后单
 * @param {Object} data 售后数据
 */
function createDentalAftersale(data) {
  return (0, _request.default)({
    url: '/admin/dental/aftersale/create',
    method: 'post',
    data: data
  });
}

/**
 * 上传口腔检查结果
 * @param {Object} data 检查结果数据
 */
function uploadDentalResult(data) {
  return (0, _request.default)({
    url: '/admin/dental/order/upload-result',
    method: 'post',
    data: data
  });
}

/**
 * 获取订单状态选项
 */
function getDentalOrderStatusOptions() {
  return (0, _request.default)({
    url: '/admin/dental/order/status/options',
    method: 'get'
  });
}

/**
 * 获取预约状态选项
 */
function getAppointmentStatusOptions() {
  return (0, _request.default)({
    url: '/admin/dental/order/appointment/status/options',
    method: 'get'
  });
}

/**
 * 口腔订单发货
 * @param {Object} data 发货信息
 */
function shipDentalOrder(data) {
  return (0, _request.default)({
    url: '/admin/dental/order/shipments',
    method: 'post',
    data: data
  });
}